















import Vue, { PropType } from 'vue';

import SerialnumbersManager from '@/containers/serialnumbers-manager';
import { DynamicDocumentItem, DynamicDocumentItemData, SerialNumber } from '@/types';
import { isItemRequired } from '@/utilities';

import documentCtxMixin from '../document-ctx';

/**
 * A serienummer question that belongs to the DOCUMENT.
 *
 * The CUSTOM serial renderers (GenericSerialNumber and friends) cannot be reused here: they write
 * into an installation's modules_data and dereference `installation.id` / `module.type` on mount,
 * neither of which a questionnaire has. Only the manager underneath them is shared, so the barcode
 * scanner behaves identically in both flows — but for how much of a barcode it keeps. An
 * installation scans inverters, whose serial is the first twelve characters; a questionnaire asks
 * for a serial by its own format, so it keeps the whole barcode and lets `patterns` judge it.
 */
export default documentCtxMixin.extend({
  components: { SerialnumbersManager },

  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    documentData: Array as PropType<DynamicDocumentItemData[]>,
  },

  computed: {
    serialNumbers(): SerialNumber[] {
      return (this.data?.value as SerialNumber[]) ?? [];
    },

    amountRequired(): number {
      return this.item.meta?.amount ?? 1;
    },

    patterns(): string[] | undefined {
      return this.item.meta?.patterns;
    },

    isRequired(): boolean {
      return isItemRequired(this.item, this.documentData ?? [this.data]);
    },
  },

  methods: {
    onInput(value: SerialNumber[]) {
      this.$set(this.data, 'value', value);
      this.$emit('save:document');
    },
  },
});
